import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormModalDiscountTest } from './FormModalDiscountTest';
import { Dialog } from 'primereact/dialog';

export const ModalDiscountTest = (props) => {
    const {
        modal, closeDialog, loading, method, handleInputChange, enable_discounts, currentExam,handleSaveDiscount
    } = props;

    if (method !== "update") return null;

    return (
        <Dialog 
            header={currentExam?.id_profile ? 'Perfil con descuento' : 'Exámen con descuento' } 
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='small-dialog'
            
        >

            <FormModalDiscountTest
                button="Exámen con descuento"
                {...{
                    closeDialog,
                    loading,   
                    modal,
                    method,
                    handleInputChange,
                    enable_discounts, 
                    currentExam,
                    handleSaveDiscount,
                    methodAction: handleSaveDiscount
                }}
            />
      </Dialog>   
    );
};
